/**
 * Created by zad on 17/4/26.
 */
import i18n from 'react-intl-universal';
import { put, call, takeLatest } from 'redux-saga/effects';
import { Global } from '../constants/actionTypes';
import message from '../components/Message';
import ajax from '../utils/ajax';

function* changeLocaleAsync(action) {
  try {
    const { locales } = i18n.options;
    const { locale } = action;
    yield call(ajax.changeLocale, locale);
    yield call(i18n.init.bind(i18n), {
      locales,
      currentLocale: action.locale,
    });
    message.info(i18n.get('settings.change-locale'));
    yield put({ type: Global.CHANGE_LOCALE_SUCCESS, locale });
  } catch (e) {
    yield put({ type: Global.CHANGE_LOCALE_FAIL });
  }
}

function* changeReadModeAsync(action) {
  try {
    const { readMode } = action;
    yield call(ajax.changeReadMode, readMode);
    yield put({ type: Global.CHANGE_READ_MODE_SUCCESS, readMode });
    message.info(i18n.get('settings.change-read-mode'));
  } catch (e) {
    yield put({ type: Global.CHANGE_READ_MODE_FAIL });
  }
}

function* changeFontTypeAsync(action) {
  try {
    const { fontType } = action;
    yield call(ajax.changeFontType, fontType);
    yield put({ type: Global.CHANGE_FONT_TYPE_SUCCESS, fontType });
    message.info(i18n.get('settings.change-font'));
  } catch (e) {
    yield put({ type: Global.CHANGE_FONT_TYPE_FAIL });
  }
}

export function* watchChangeLocale() {
  yield takeLatest(Global.CHANGE_LOCALE, changeLocaleAsync);
}

export function* watchChangeReadMode() {
  yield takeLatest(Global.CHANGE_READ_MODE, changeReadModeAsync);
}

export function* watchChangeFontType() {
  yield takeLatest(Global.CHANGE_FONT_TYPE, changeFontTypeAsync);
}



// WEBPACK FOOTER //
// ./src/sagas/GlobalSaga.js